function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0919 0.968663C10.4494 0.193791 11.5506 0.193793 11.9081 0.968665L14.1512 5.83177C14.2969 6.14758 14.5961 6.36502 14.9415 6.40597L20.2598 7.03653C21.1072 7.137 21.4475 8.18439 20.821 8.76376L16.889 12.3999C16.6337 12.636 16.5194 12.9878 16.5872 13.329L17.6309 18.5818C17.7972 19.4187 16.9062 20.0661 16.1616 19.6493L11.4884 17.0334C11.185 16.8635 10.815 16.8635 10.5116 17.0334L5.83836 19.6493C5.09375 20.0661 4.20279 19.4187 4.3691 18.5818L5.41282 13.329C5.4806 12.9878 5.36629 12.636 5.11095 12.3999L1.17903 8.76376C0.552527 8.18439 0.892845 7.137 1.74024 7.03653L7.05849 6.40597C7.40386 6.36502 7.70314 6.14758 7.84881 5.83177L10.0919 0.968663Z",
  fill: "currentColor"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.51a15f15.svg";
export { ForwardRef as ReactComponent };